import { Box, Button, Dialog } from "@mui/material"
import CloseModalButton from "../../../../components/CloseModalButton"
import { StyledDialogContent, StyledDialogFooter, StyledDialogTitle } from "../../../../components/Dialog.styled"
import WarningIcon from "@mui/icons-material/Warning"

type AutoclaveWarningModal = {
  open: boolean,
  handleClose: () => void,
}

const AutoclaveWarningModal = (props: AutoclaveWarningModal) => {
  const { open, handleClose } = props

  return (
    <Dialog open={open} onClose={handleClose}>
      <CloseModalButton handleClose={handleClose} />
      <StyledDialogTitle>
        <Box className="flex flex-align-center c-g-8">
          <WarningIcon fontSize="small" />
          <span>Warning</span>
        </Box>
      </StyledDialogTitle>
      <StyledDialogContent>
        Please re-assign spore test boxes before deleting autoclave.
      </StyledDialogContent>
      <StyledDialogFooter>
        <Button variant="contained" onClick={handleClose}>
          Continue
        </Button>
      </StyledDialogFooter>
    </Dialog>    
  )
}

export default AutoclaveWarningModal
